import { Flex } from "@chakra-ui/react";
import { DatePicker, DatePickerProps } from "antd";
import moment from "moment";
import { useState } from "react";
import { Container } from "./styles";

interface SelectMonthYearProps {
  bg?: string;
  format?: string;
  mt?: string;
}

function SelectMonthYear({
  style,
  format = "MMMM YYYY",
  mt = "",
  ...rest
}: SelectMonthYearProps & DatePickerProps) {
  const [open, setOpen] = useState(false);

  const styles: any = {
    minWidth: 200,
    backgroundColor: rest.bg,

    ...style,
  };

  if (rest.bg) {
    styles.border = "1px solid #ccc";
  }
  return (
    <Container>
      <Flex mt={mt} cursor="pointer">
        <DatePicker
          getPopupContainer={(node) => node.parentNode as any}
          allowClear={false}
          format={format}
          monthCellRender={(date) => (
            <div className="ant-picker-cell-inner">
              {moment(date).format("MMM")}
            </div>
          )}
          locale={{
            timePickerLocale: {
              placeholder: "Selecione um horário",
            },
            lang: {
              locale: "pt-br",
              today: "Hoje",
              now: "Agora",
              backToToday: "Voltar a hoje",
              clear: "Limpar",
              month: "Mês",
              year: "Ano",
              dateFormat: "DD/MM/YYYY",
              timeSelect: "Selecione um horário",
              dateSelect: "Selecione uma data",
              monthSelect: "Selecione um mês",
              decadeSelect: "Escolha uma década",
              yearFormat: "YYYY",
              monthFormat: "MMMM",
              dayFormat: "DD",
              dateTimeFormat: "DD/MM/YYYY HH:mm:ss",
              monthBeforeYear: true,
              previousMonth: "Mês anterior",
              nextMonth: "Próximo mês",
              previousYear: "Ano anterior",
              nextYear: "Próximo ano",
              previousDecade: "Década anterior",
              nextDecade: "Próxima década",
              previousCentury: "Século anterior",
              nextCentury: "Próximo século",
              placeholder: "Selecione uma data",
              yearSelect: "Selecione um ano",
              shortMonths: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
              ],
              weekSelect: "Selecione uma semana",
              shortWeekDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
              ok: "Ok",
            },
            monthFormat: "MMM",
            dateFormat: "DD MMM YYYY",
          }}
          picker="month"
          suffixIcon={
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="down"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              style={{ width: 12, height: 12 }}
            >
              <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
            </svg>
          }
          style={styles}
          open={open}
          onOpenChange={setOpen}
          {...rest}
        />
      </Flex>
    </Container>
  );
}

export default SelectMonthYear;
